import React from "react";
import { View, ViewProps } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

interface Props extends ViewProps {
  children: React.ReactNode;
}

export default function AppScreen({ children, style, ...props }: Props) {
  const insets = useSafeAreaInsets();

  return (
    <View
      style={[
        {
          flex: 1,
          paddingTop: insets.top,
        },
        style,
      ]}
      {...props}
    >
      {children}
    </View>
  );
}
